/**
 * (c) 希博辅考网
 */

let url = 'https://api.cqxibo.com';

export default {
    url: url
}